import { LotacaoInput } from 'graphql/types.generated'

import { LotacaoFormModel } from './LotacaoForm'

export default function convertModelToInput(model: LotacaoFormModel): LotacaoInput {
  return {
    ...model,
    cbo: model.cbo.id,
    equipe: model.equipe && model.equipe.id,
    unidadeSaude: model.unidadeSaude.id,
    perfis: model.perfis?.map((p) => p.id),
    atualizaPerfil: model.atualizaPerfil,
  }
}
